import { extract_workflow_identifier } from './esigning_setup_helpers';

const esigning_setup_computed = {
  template_display_name() {
    return this.template_name || 'Selected Template';
  },

  selected_form() {
    return this.template_forms.find((form) => form.id === this.selected_form_id) || null;
  },

  assigned_form_id() {
    const active_assignment = Object.values(this.template_form_assignments || {})
      .find((item) => item?.is_active !== false);

    return String(active_assignment?.template_form_id || '').trim();
  },

  assigned_form() {
    if (!this.assigned_form_id) return null;

    return this.template_forms.find(
      (form) => String(form.id) === this.assigned_form_id,
    ) || null;
  },

  selected_workflow() {
    return this.workflows.find((workflow) => workflow.id === this.selected_workflow_id) || null;
  },

  assigned_workflow_id() {
    return extract_workflow_identifier(this.assigned_workflow_binding)
      || extract_workflow_identifier(this.active_template_entity_type_assignment)
      || String(this.route_workflow_id || '').trim();
  },

  assigned_workflow() {
    if (!this.assigned_workflow_id) return null;

    return this.workflows.find(
      (workflow) => String(workflow.id) === this.assigned_workflow_id,
    ) || null;
  },

  active_template_entity_type_assignment() {
    const assignments = Array.isArray(this.template_entity_type_assignments)
      ? this.template_entity_type_assignments
      : [];

    return assignments.find((assignment) => assignment?.is_assigned !== false) || null;
  },

  setup_progress() {
    const assigned_count = [this.assigned_form, this.assigned_workflow].filter(Boolean).length;

    return [
      {
        title: 'Template selected',
        detail: this.template_display_name,
        complete: Boolean(this.template_id || this.template_name),
      },
      {
        title: 'Form assigned',
        detail: this.assigned_form?.name || 'Choose a template form',
        complete: Boolean(this.assigned_form_id),
      },
      {
        title: 'Workflow assigned',
        detail: this.assigned_workflow?.name || 'Choose a workflow',
        complete: Boolean(this.assigned_workflow_id),
      },
      {
        title: 'Ready to configure',
        detail: assigned_count === 2
          ? 'Docuseal tagging can start next'
          : 'Complete the assignments first',
        complete: assigned_count === 2,
      },
    ];
  },

  completion_ratio() {
    return `${this.setup_progress.filter((item) => item.complete).length}/${this.setup_progress.length}`;
  },

  base_setup_query() {
    return {
      ...(this.template_id ? { template_id: this.template_id } : {}),
      ...(this.template_name ? { template_name: this.template_name } : {}),
      ...(this.template_type ? { template_type: this.template_type } : {}),
      ...(this.template_bindings ? { bindings: this.template_bindings } : {}),
      ...(this.route_template_entity_type_id ? { template_entity_type_id: this.route_template_entity_type_id } : {}),
      ...(this.route_workflow_id ? { workflow_id: this.route_workflow_id } : {}),
    };
  },

  setup_query() {
    return {
      ...this.base_setup_query,
      ...(this.assigned_form?.id ? { template_form_id: String(this.assigned_form.id) } : {}),
      ...(this.assigned_form?.onboarding_form_id
        ? { onboarding_form_id: String(this.assigned_form.onboarding_form_id) }
        : {}),
      ...(this.active_template_entity_type_assignment?.id
        ? { template_entity_type_id: String(this.active_template_entity_type_assignment.id) }
        : {}),
      ...(this.assigned_workflow_id ? { workflow_id: this.assigned_workflow_id } : {}),
    };
  },
};

export default esigning_setup_computed;
